import { CosmeticType } from 'src/utils/types';
export const parseCosmeticType = type => {
  if (!type) {
    return '';
  }

  switch (type) {
    case CosmeticType.AVATAR:
      {
        return 'Avatar';
      }

    case CosmeticType.AVATAR_FRAME:
      {
        return 'Avatar Frame';
      }

    case CosmeticType.EMOTE:
      {
        return 'Emote';
      }

    case CosmeticType.SPACESHIP:
      {
        return 'SpaceShip';
      }

    default:
      {
        return '';
      }
  }
};